import { useContext, useEffect, useState } from "react";
import { QueryParams } from "../shared/api-interfaces";
import AppContext from "../contexts/AppContext";

export function useCount(query: QueryParams) {
  const context = useContext(AppContext);

  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState(-1);
  const [error, setError] = useState("");

  useEffect(() => {
    function fetchData() {
      if (result > 0) {
        setResult(0);
      }
      setLoading(true);

      context.api
        .getCount(query)
        .then((c) => setResult(c))
        .catch((e) => setError(e.message))
        .finally(() => setLoading(false));
    }

    setError(null);

    if (query) {
      fetchData();
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  return {
    error,
    loading,
    result,
  };
};
